import React from 'react';
import VoucherStatus from '../../../shared/Point/Filters/VoucherStatus/VoucherStatus';
import RangePicker from '../../../shared/Point/Filters/RangePicker/RangePicker';
import { VOUCHER_FILTER_PERIODS } from '../../../../constants/defaultValues';
import { generateCustomDate, downloadFile } from '../../../../utils/helpers';
import AgentService from '../../../../services/AgentService';
import styles from './Filters.module.scss';
import { getTranslation } from '../../../../utils/translation';

export default function Filters(props) {
    const { filters, setFilters, onSearch, clearData } = props;

    const onPeriodChange = period => {
        clearData();
        setFilters(filters => ({ ...filters, period }));
    };

    const onDateChange = date => {
        setFilters(
            filters => ({
                ...filters,
                period: generateCustomDate(filters.period, date),
            }),
            { runSearch: false },
        );
    };

    const onStartDateChange = date => {
        onDateChange({ startTime: date.setHours(0, 0, 0, 0) });
    };

    const onEndDateChange = date => {
        onDateChange({ endTime: date.setHours(23, 59, 59, 999) });
    };

    const onStatusChange = status => {
        setFilters(filters => ({ ...filters, status: status.value }));
    };

    return (
        <div className={`${styles.container} filters`}>
            <div className={styles.filtersContainer}>
                <VoucherStatus selectedStatus={filters.status} onStatusChange={onStatusChange} />
                <RangePicker
                    periods={VOUCHER_FILTER_PERIODS}
                    selectedPeriod={filters.period}
                    onPeriodChange={onPeriodChange}
                    startDate={filters.period.getRange().startTime}
                    endDate={filters.period.getRange().endTime}
                    onStartDateChange={onStartDateChange}
                    onEndDateChange={onEndDateChange}
                    showTime
                    onSearch={onSearch}
                />
            </div>
            <button
                className='filter-button m-l-3'
                onClick={() => downloadFile(AgentService.downloadUnusedVouchers, 'unused-vouchers.xlsx')}
            >
                {getTranslation('exportButton')}
            </button>
        </div>
    );
}
